import React from 'react'

import assetUrl from 'src/utils/assetUrl'

const aboutInitiative = assetUrl(RAILS_ASSET_URL('/cpwm/about-initiative.jpg'))

const InitiativePanel = props =>
  <article>
    <img
      className="img-fluid w-100"
      src={aboutInitiative}
      alt={props.title}
    />

    <div className="t-spacing px-3 py-4 p-sm-5 p-lg-4 p-xl-5">
      <header className="mb-5">
        <h6 className="text-primary text-uppercase d-block mb-3">
          About {props.title}
        </h6>

        <h1>
          Rebuilding Homes Together
        </h1>

        <hr className="border-primary hr-thicc" />
      </header>

      <div>
        <p className="text-black-50">
          At Cost Plus World Market we value our community, our neighbors, and
          our families. And that’s why we’re raising donations for Rebuilding
          Together, an organization that mobilizes communities to provide
          everyone with a safe, accessible place they can call home. From
          providing critical repairs and renovations, to installing wheelchair
          ramps and railings, to rehabilitating local parks, Rebuilding Together
          makes communities safer and stronger and we are proud to be a part of
          it.
        </p>
      </div>
    </div>
  </article>

export default InitiativePanel
